const Contact = () => {
    return (
        <section id="contact">
            <h2>Contact</h2>
            <p>Email: kumaravinashsharma82@gmail.com</p>
            <p>Phone: +91 9060071846</p>
            <p>LinkedIn: <a href="https://linkedin.com/in/avinashksharma" target="_blank" rel="noreferrer" className="App-link">LinkedIn</a></p>
            <p>GitHub: <a href="https://github.com/avinash-sharma-121" target="_blank" rel="noreferrer" className="App-link">GitHub</a></p>
        </section>
    )
}

export default Contact;